import { Box } from "@mui/material";
import React, { useEffect } from "react";
import shallow from "zustand/shallow";
import { FxButton } from "../button/FxButton";
import { FormComponent } from "../formcomponent/FormComponent";
import { session, useNavigation } from "../helpers";
import { useParams } from "react-router-dom";
import { TokenContext } from "../../../context-helpers/TokenContext";

export const useBaseForm = (props: any) => {
    const { getToken } = React.useContext(TokenContext);

    const { storeHook, customRenderer } = props;
    const { formConfig, formModel, _id, lookup, validationMap, errors, getItemById, getLookups, addItem,
        updateItem, handleInputChange, handleFormModelChange, handleArrayInputChange, addItemToArray,
        deleteItemFromArray, setFormOptions, processCascadingLookups, loadAllCacadingLookups,
        resetFormModel } = storeHook((state: any) =>
        ({
            formConfig: state.formConfig,
            formModel: state.formModel,
            _id: state._id,
            lookup: state.lookup,
            validationMap: state.validationMap,
            errors: state.errors,
            getItemById: state.getItemById,
            getLookups: state.getLookups,
            addItem: state.addItem,
            updateItem: state.updateItem,
            handleInputChange: state.handleInputChange,
            handleFormModelChange: state.handleFormModelChange,
            handleArrayInputChange: state.handleArrayInputChange,
            addItemToArray: state.addItemToArray,
            deleteItemFromArray: state.deleteItemFromArray,
            setFormOptions: state.setFormOptions,
            processCascadingLookups: state.processCascadingLookups,
            loadAllCacadingLookups: state.loadAllCacadingLookups,
            resetFormModel: state.resetFormModel
        }), shallow);
    const { back } = useNavigation();
    const params: any = useParams();

    const getCompToken = async () => {
        let token: any = await getToken();
        session.setItem("accessToken", token);
    }

    useEffect(() => {
        getCompToken();
        if (!params._id || params._id == '0' || params._id == 0) {
            clearFormData();
        } else {
            getById(params._id);
        }
        initLookup();
    }, [params._id]);

    const getById = async (id: any) => {
        if (id) {
            await getItemById(id);
        }
    }
    const initLookup = async () => {
        await getLookups();
        await loadAllCacadingLookups();
    }

    const clearFormData = async () => {
        await resetFormModel();
    }

    const navBack = async (options: any = {}) => {
        await resetFormModel();
        back();
    }

    const computeCallback = (data: any) => {
        setFormOptions(data);
    }

    const renderAddAction = (action: any, jdx: any) => {
        return <> {(params._id == '0' || params._id == 0) && <FxButton label="Add" variant="contained" size="small" onClick={() => addItem(navBack)} />} </>
    }

    const renderUpdateAction = (action: any, jdx: any) => {
        return <> {(params._id != '0' || params._id != 0) && <FxButton label="Update" variant="contained" size="small" onClick={() => updateItem(navBack)} />} </>
    }

    const renderCancelAction = (action: any, jdx: any) => {
        return <FxButton label="Cancel" className="m-left-2" variant="contained" size="small" color="error" onClick={navBack} />
    }

    const renderFormComp = (control: any, id: any) => {
        return <FormComponent
            controls={control?.controls}
            formModel={formModel}
            formModelId={_id}
            id="1000"
            layout={control?.layout}
            handleInputChange={handleInputChange}
            handleArrayInputChange={handleArrayInputChange}
            addItemToArray={addItemToArray}
            deleteItemFromArray={deleteItemFromArray}
            validationMap={validationMap}
            processCascadingLookups={processCascadingLookups}
            lookup={lookup}
            errors={errors}
            computeCallback={computeCallback}
            customRenderer={customRenderer} />
    }

    const sectionMap: any = {
        form: renderFormComp
    }

    const actionsMap: any = {
        add: renderAddAction,
        update: renderUpdateAction,
        cancel: renderCancelAction
    }

    const renderForm = () => {
        return (
            <div className="container-fluid">
                <Box className="content-heading">
                    <Box className="page-title">{formConfig?.pageTitle}</Box>
                </Box>
                <Box className="content-body">
                    {formConfig && formConfig.sections && formConfig.sections.map((control: any, idx: any) => (
                        <>
                            {sectionMap[control.type](control, idx)}
                        </>
                    ))}
                    <Box sx={{ textAlign: 'right' }} className="mt-3">
                        {formConfig && formConfig.sections && formConfig.sections.map((control: any, idx: any) => (
                            <>
                                {control.actions && control.actions.map((action: any, jdx: any) => (
                                    <>
                                        {actionsMap[action.name](action, jdx)}
                                    </>
                                ))}
                            </>
                        ))}
                    </Box>
                </Box>
            </div>
        );
    }

    return {
        renderForm, formModel, _id, lookup, getLookups, getItemById,
        handleArrayInputChange, addItemToArray, deleteItemFromArray,
        addItem, updateItem, handleInputChange, handleFormModelChange, validationMap, errors, navBack,
        clearFormData
    };
}